import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';

import { EXPORT_VIEWS, exportModalReducerKey } from './ExportModalConstants';
import {
  entries as entriesSelector,
  isLoading as isLoadingSelector,
  errors as errorsSelector,
  currentView as currentViewSelector,
  data as dataSelector,
  formData as formDataSelector,
  isSelectionExportActive as isSelectionExportActiveSelector,
  formatsBackup as formatsBackupSelector,
  exportType as exportTypeSelector,
  selectedDatapoints as selectedDatapointsSelector,
  isResultsExport as isResultsExportSelector,
  isChemQuoteExport as isChemQuoteExportSelector,
  isFormAcceptable as isFormAcceptableSelector,
  isBusy as isBusySelector,
} from './ExportModalSelectors';
import ExportModalReducer from './ExportModalReducer';

import {
  initialize,
  closeExportModal,
  setFormat,
  setExport,
  setRange,
  signIn,
  apply,
  applyDatapoints,
  getDatapoints,
  changeDatapoints,
  trackAdobeAnalyticsError,
  setCurrentView,
  setRangeOptions,
  setExportOptions,
  setFormDataOptionsHeadline,
} from './ExportModalActions';
import ExportModal from './ExportModal';

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  entries: entriesSelector(state),
  errors: errorsSelector(state),
  data: dataSelector(state),
  formData: formDataSelector(state),
  isSelectionExportActive: isSelectionExportActiveSelector(state),
  formatsBackup: formatsBackupSelector(state),
  exportType: exportTypeSelector(state),
  selectedDatapoints: selectedDatapointsSelector(state),
  isResultsExport: isResultsExportSelector(state),
  isChemQuoteExport: isChemQuoteExportSelector(state),
  isFormAcceptable: isFormAcceptableSelector(state),
  isBusy: isBusySelector(state),
  currentView: currentViewSelector(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  initialize: (...args) => dispatch(initialize(ownProps, ...args)),
  close: () => dispatch(closeExportModal()),
  setFormat: (index) => dispatch(setFormat(index)),
  setExport: (index) => dispatch(setExport(index)),
  setRange: (index) => dispatch(setRange(index)),
  setRangeOptions: (name, value) => dispatch(setRangeOptions(name, value)),
  setExportOptions: (index) => dispatch(setExportOptions(index)),
  setFormDataOptionsHeadline: (value) => dispatch(setFormDataOptionsHeadline(value)),
  signIn: () => dispatch(signIn(ownProps.parentParams.context)),
  apply: () => dispatch(apply(ownProps.parentParams)),
  applyDatapoints: () => dispatch(applyDatapoints()),
  getDatapoints: () => dispatch(getDatapoints()),
  changeDatapoints: (datapoints) => dispatch(changeDatapoints(datapoints)),
  trackAdobeAnalyticsError: () => dispatch(trackAdobeAnalyticsError()),
  cancelDatapoints: () => dispatch(setCurrentView(EXPORT_VIEWS.MAIN)),
  openDatapointsView: () => dispatch(setCurrentView(EXPORT_VIEWS.DATAPOINTS)),
});

export default compose(withReducer(exportModalReducerKey, ExportModalReducer), connect(mapStateToProps, mapDispatchToProps))(ExportModal);
